export const TrLocale = {
    page: {
        txtTitle: 'SHIRITORI | Eğlenceli しらとり oyunu ile çevrimiçi Japonca kelime öğrenmeyi kolaylaştırın',
    },
    common: {
        txtLogoAlt: 'Shiritori treni',
    },
    header: {
        txtLeave: 'OYUNDAN AYRIL',
    },
    dialog: {
        leave: {
            txtTitle: 'Bu oyundan ayrılmak istiyor musun?',
            btnStay: 'OYUNDA KAL',
            btnLeave: 'AYRIL VE HÜKMEN YENİL',
        },
    },
    home: {
        btnNewGame: 'YENİ OYUN',
        btnMainMenu: 'ANA MENÜ',
        btnJoinGame: 'KATIL',
        btnReturnToGame: 'OYUNA DÖN',
    },
    create: {
        headingNamePrompt: 'Sana nasıl hitap edelim?',
        placeholderName: 'Adın',
        btnOk: 'TAMAM',
    },
    join: {
        placeholderName: 'Adın',
        placeholderGameId: 'oyun id',
        btnJoinGame: 'KATIL',
    },
    configure: {
        header: 'OYUN AYARLARI',
        labelExpectedPlayers: 'Oyuncu sayısı',
        labelBoardSize: 'Tahta boyutu',
        labelWordList: 'Kelime listesi',
        labelAllowHints: 'İpuçlarına izin ver',
        labelTurnTimer: 'Tur sayacı',
        optionNoTimer: 'Sayaç yok',
        optionTimer: 'Sayaç',
        unitSeconds: 'sn',
        btnStartGame: 'BAŞLAT',
        toastCreateError: 'Hata: Bu oyun oluşturulamıyor',
        toastTryAgain: 'Hata: Lütfen daha sonra tekrar deneyin.',
    },
    game: {
        lobby: {
            btnReady: 'Hazır',
            txtShareInvite: 'Bu kodu arkadaşlarınla paylaş!',
            txtPlayer: 'Oyuncu',
            txtTeam: 'Takım',
        },
        message: {
            noSuchGame: 'Bu oyun mevcut değil',
            txtLoading: 'Yükleniyor...',
            txtCannotJoin: 'Oyuna katılamadı',
        },
        gameplay: {
            board: {
                timeoutTitle: 'SÜRE',
                timeoutSubtitle: 'doldu',
            },
            wordSearch: {
                multipleMatches: 'BİRDEN FAZLA EŞLEŞME BULUNDU!',
                yourTurn: 'SIRA SENDE',
                placeholder: 'Hangi kelimeyi oynayalım?',
                playAction: 'OYNA',
                timerSeconds: '{{seconds}}sn',
                toastNoSuchWord: 'Böyle bir kelime yok!',
                toastCantPlay: 'Bu kelime oynanamaz!',
                toastPlayed: '"{{word}}" oynandı',
                toastPlayFailed: 'Oops, bu kelime oynanamadı!',
                validation: {
                    syllableMismatch: 'Başlangıç hecesi eşleşmiyor',
                    missingLastWord: 'Son turda kelime yok',
                    wordNotInList: 'Kelime seçili listede yok',
                }
            },
            spectate: {
                waitingOn: '{{player}} bekleniyor',
                timeLeft: 'Kalan süre: {{seconds}}sn',
            },
            endGame: {
                header: 'OYUN BİTTİ',
                viewResults: 'SONUÇLARI GÖR',
                statsTotalTime: 'Toplam oyun süresi',
                statsSquaresFilled: 'Doldurulan kareler',
                statsLongestWord: 'En uzun kelime',
                share: 'Paylaş',
                sharing: 'Paylaşılıyor...',
                ariaCloseLabel: 'Oyun sonu penceresini kapat',
            }
        },
    },
    footer: {
        linkHowToPlay: 'Nasıl Oynanır',
        linkPrivacyPolicy: 'Gizlilik Politikası',
        txtAllRightsReserved: 'Tüm hakları saklıdır.',
    },
    howToPlay: {
        title: 'Shiritori しりとり (shiritori) nasıl oynanır',
        btnPlayNow: 'Hemen oyna!',
        btnReturnToGame: 'Oyuna dön:',
        description1: 'b|Shiritori|, Japonca kelime zinciri oyunu しりとり için çevrimiçi çok oyunculu yorumumuzdur. Arkadaşlarınla veya tek başına kelime çalışırken görsel bir tahta oluştur.',
        description2: 'Bir oyun oluştur ya da katıl, tahta boyutunu, görsel setini ve kelime listesini seç; sonra biri hata yapmadan önce geçerli kelimelerle ızgarayı doldurmak için yarış.',
        gameSetup: {
            title: 'Oyun oluştur veya katıl',
            p1: 'Tek oyuncu başla veya paylaşılabilir bağlantı/oyun kodu ile en fazla 9 arkadaşını davet et (toplam 10 oyuncu).',
            p2: 'İstediğin seçenekleri seç: tahta boyutu (3x3, 5x5, 7x7), arka plan deseni/rengi, görsel seti ve çalışılacak kelime listesi.',
            p3: 'Arkadaşlar bağlantıyı açar, takma ad seçer ve lobiye gelir; beklenen oyuncu sayısı tamamlanınca oyun başlar.',
            p4: 'Geç gelenler de devam eden maçı yalnızca izleme modunda takip edebilir.',
        },
        objective: {
            title: 'Amaç',
            p1: 'Her yeni kelime önceki kelimenin son hecesiyle başlasın, tahtayı doldur ve hiçbir kelimeyi ん ile bitirme.',
        },
        wordRules: {
            title: 'Geçerli kelimeler',
            p1: 'Kana veya romaji ile yaz; romaji kontrol edilmeden önce istemci tarafında hiraganaya dönüştürülür.',
            p2: 'Kelimeler seçilen listede bulunmalıdır (100/1000 yaygın, yemekler, spor vb.) ve oynadıktan sonra anlamları gösterilir.',
            p3: 'Kullanılmış kelimeler engellenir. Eşsesli kelimelere izin veriliyorsa, doğru görselle kullanılmamış bir varyant seçebilirsin.',
            li1: 'Önceki turdan gelen gerekli heceyle başlar',
            li2: 'ん (n) ile bitmez',
            li3: 'Seçilen kelime listesinde bulunur',
            li4: 'Bu oyunda daha önce oynanmamıştır',
            li5: 'Kural açıksa izin verilen eşsesli/görsel kullanır',
            p4: 'Her geçerli hamle görselini sırayla tahtaya bırakır; ızgara soldan sağa, yukarıdan aşağıya dolar. e|Örnek:_そば_→_バス|',
        },
        turnFlow: {
            title: 'Turlar ve zamanlama',
            p1: 'Turlar oyuncu listesinde sırayla döner; aktif olduğunda, sıranı gördüğün andan itibaren en fazla 10 saniyen olur.',
            p2: 'Shiritori, sonraki oyuncu aktif olana kadar (tarayıcı odakta) geri sayımı başlatmaz; böylece yeniden başlatma/yenileme ile süre atlanamaz.',
            p3: 'Kelimeyi gir, canlı doğrulamayı izle ve süre dolmadan gönder; geçersiz veya geç gönderimler maçı hemen bitirir.',
        },
        boardFlow: {
            title: 'Tahta, akış ve bitiş',
            p1: 'Tahta, oynanan her kelimeyi görseli, oyuncu adı ve tur numarasıyla gösterir; oklar ızgaradaki sırayı izletir.',
            p2: 'Sıra başkasındayken de gerekli başlangıç hecesini ve geri sayımı görebilirsin.',
            p3: 'Tüm alanlar geçerli kelimelerle dolarsa oyun başarıyla biter ve paylaşım için tamamlanmış tahta gösterilir.',
            p4: 'Süre dolmadan geçerli hamle gönderilmezse, kimin süresi dolduğunu veya geçersiz kelime oynadığını özetleyen ekranla oyun biter.',
        },
        summary: {
            title: 'Özet',
            p1: 'Shiritori shiritori oyununu hızlı ve görsel tutar: kısa turlar, net kurallar ve görsel çağrışımlar zinciri canlı tutmaya yardımcı olur.',
            p2: 'Bir bağlantı paylaş, tahtayı doldur ve kelime zincirinin ne kadar uzayabileceğini gör.',
        }
    },
    bugsAndFeatures: {
        title: 'Hata bildirimleri ve yeni özellikler',
        p1: 'Bu oyunu klasik k|しりとり.| oyununu farklı bir şekilde oynamak için yaptık. Oyunları seven bir ekip olarak, oyunu daha keyifli hale getirmek için her zaman geliştirme yolları arıyoruz.',
        cta: {
            l1: 'Aslında bize ',
            a: 'oyunumuzu arkadaşlarınla paylaşarak',
            l2: ' sosyal medyada destek olmanı çok isteriz!'
        },
        p2: 'Herhangi bir hata ile karşılaşırsan veya yeni özellik önerin varsa lütfen bize bildir!',
        bugs: {
            title: 'Hatalar',
            p1: 'Lütfen garip davranışları, hataları veya bugları doğrudan herkese açık a|https://github.com/indexinteractive/|GitHub_depomuzda| bildir. Hatayı yeniden üretme adımları dahil olabildiğince fazla detay paylaşmayı unutma.'
        },
        features: {
            title: 'Yeni özellikler',
            p1: 'Yeni özellik, iyileştirme veya oyun fikri önerilerin varsa, a|https://github.com/indexinteractive/|GitHub_Discussions| sayfamızda yeni bir tartışma açarak bize ilet.'
        }
    },
    share: {
        title: 'Shiritori | Eğlenceli しらとり oyunu ile çevrimiçi Japonca kelime öğrenmeyi kolaylaştırın - SHIRITORI',
        text: 'Shiritori oyununu arkadaşlarınla veya rastgele oyuncularla çevrimiçi oyna. Kayıt gerektirmez!',
    }
};
